/** Shared so the nav and the open menu card cannot drift apart. */
export const NAV_WORDMARK_CLASSES =
  "h-[32px] w-auto tab:h-[34px] sd:h-[50px] d:h-[52px]";
